import React from 'react';

// Images
import SlackLogo from 'Shared/images/slackLogo.svg';

// Hooks
import { useTrackPiSuggestedTopics } from 'Shared/tracking/use-track-pi-suggested-topics';

// Types
import { PiSuggestedTopicsCategories } from 'Shared/types/PiSuggestedTopic.type';

// Components
import {
  WpDropdown,
  WpDropdownToggle,
  WpDropdownMenu,
  WpDropdownMenuDivider,
  WpDropdownMenuItem,
} from 'Wpds/components/dropdown';
import { WpButton } from 'Wpds/components/button';
import { WpIcon } from 'Wpds/components/icon';
import { WpText } from 'Wpds/components/text';

// Styles
import './PiSuggestedTopicsCategoryDropdown.scss';

type Props = {
  selectedCategory: string;
  handleSelectCategory: Function;
  showPiCategories?: boolean;
  showAgendaAiOnly?: boolean;
};

const PiSuggestedTopicsCategoryDropdown = ({
  selectedCategory,
  handleSelectCategory,
  showPiCategories = true,
  showAgendaAiOnly = false,
}: Props) => {
  const { trackChangedCategory } = useTrackPiSuggestedTopics();

  const handleChangeCategory = category => {
    trackChangedCategory({ category });
    handleSelectCategory(category);
  };

  const options: { value: string; label?: string; image?: string }[] = [
    ...(showPiCategories
      ? [
          {
            value: 'all',
            label: 'All Topics',
          },
          ...Object.keys(PiSuggestedTopicsCategories).map(key => ({
            value: key,
            label: PiSuggestedTopicsCategories[key],
          })),
        ]
      : [
          {
            value: 'all',
            label: 'PI topics',
          },
        ]),
    { value: 'divider' },
    { value: 'agendaAI', label: 'Slack AgendaAI', image: SlackLogo },
  ];

  const selectedOption = options.find(option => option.value === selectedCategory);

  const baseClassName = 'PiSuggestedTopicsCategoryDropdown';

  // GroupWorkspaces and private workspace only get AgendaAi option, so no dropdown
  if (showAgendaAiOnly) {
    return (
      <div className={`${baseClassName}__group-name`}>
        {selectedOption.image && (
          <img src={selectedOption.image} className={`${baseClassName}__option__image`} alt="slack logo" />
        )}
        <WpText noMargin bold>
          {selectedOption.label}
        </WpText>
      </div>
    );
  }

  return (
    <WpDropdown>
      <WpDropdownToggle>
        <WpButton color="gray" variant="secondary">
          {selectedOption.image && (
            <img src={selectedOption.image} className={`${baseClassName}__option__image`} alt="slack logo" />
          )}
          {selectedOption.label} <WpIcon name="angle-down" />
        </WpButton>
      </WpDropdownToggle>
      <WpDropdownMenu>
        {options.map(category => {
          if (category.value === 'divider') return <WpDropdownMenuDivider key={category.value} />;
          return (
            <WpDropdownMenuItem onClick={() => handleChangeCategory(category.value)} key={category.value}>
              {category.image && (
                <img src={category.image} className={`${baseClassName}__option__image`} alt="slack logo" />
              )}
              {category.label}
            </WpDropdownMenuItem>
          );
        })}
      </WpDropdownMenu>
    </WpDropdown>
  );
};

export default PiSuggestedTopicsCategoryDropdown;
